import { useState, type InputHTMLAttributes } from 'react';
import { IconEye, IconEyeOff } from '@/components/Icons';

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  /** Controlado por fora, quando o pai precisa mostrar a senha — por exemplo, logo depois de gerar. */
  visible?: boolean;
  onVisibleChange?: (visible: boolean) => void;
}

/** Campo de senha com o olho para mostrar e esconder; à vista, em fonte mono. */
export function PasswordInput({ value, onChange, visible: controlled, onVisibleChange, id, ...rest }: PasswordInputProps) {
  const [own, setOwn] = useState(false);
  const visible = controlled ?? own;

  function toggle() {
    if (onVisibleChange) onVisibleChange(!visible);
    else setOwn(!visible);
  }

  return (
    <div className="password-input">
      <input
        {...rest}
        id={id}
        className="inp"
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
      />
      <button
        type="button"
        className="icon-btn password-toggle"
        aria-label="Mostrar senha"
        aria-pressed={visible}
        aria-controls={id}
        title={visible ? 'Esconder senha' : 'Mostrar senha'}
        disabled={rest.disabled}
        onClick={toggle}
      >
        {visible ? <IconEyeOff /> : <IconEye />}
      </button>
    </div>
  );
}
